import { CustomWindow } from '../../../index.d';

declare let window: CustomWindow;

export const getActiveCurrency = (): string =>
	window.Shopify?.currency?.active || window.LittledataLayer?.ecommerce?.currencyCode; //fallback to shop currency
